import React from 'react';
import { Divider, Stack, SxProps } from '@mui/material';
import { sidepanelMaxWidth, rightSidepanelMinWidth } from '../../../Constants';

/** Stack styles. */
const stackSx: SxProps = {
    height: '100%',
    overflow: 'hidden',
};

export default (props: ISidepanelWrapperProps) => {
    const { isExpanded, addDivider, children } = props;
    return (
        <Stack
            sx={{
                ...stackSx,
                width: isExpanded ? sidepanelMaxWidth : rightSidepanelMinWidth,
            }}
            divider={addDivider && <Divider flexItem />}
        >
            {children}
        </Stack>
    );
};

/**
 * Interface that describes the props for the Sidepanel's Wrapper.
 */
export interface ISidepanelWrapperProps {
    /** Children of the component. */
    children: React.ReactNode;

    /** Boolean that shows whether the sidepanel is expanded. */
    isExpanded: boolean;

    /** Boolean that shows whether to add a divider. */
    addDivider: boolean;
}
